import { HIGHEST_OI, HIGHEST_OI_STREAM, } from "../../../interface/drivingMarket/highestOI/highestOI";
import { drivingMarketOptionsStream } from "@domains/features/Markets/Options/utils/streamUpdate";
let initState = {
    data: {},
};
const HighestOI = (state = initState, action) => {
    switch (action.type) {
        case HIGHEST_OI:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case HIGHEST_OI_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketOptionsStream(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default HighestOI;
